import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Forms, Modal, SaveButton, SystemText } from 'e4shared';
import { apiPost } from 'services';
import { setShowSuccess, toggleFormHelp } from 'actions/ui';
import { addDays, endOfDay, isPast } from 'helpers/dates';

export const Enroll = ({ show, close, reload, pathways, profile }) => {
    const dispatch = useDispatch();
    const [pathwayId, setPathwayId] = React.useState(null);
    const [due, setDue] = React.useState(null);
    const [launch, setLaunch] = React.useState(null);
    const [saving, setSaving] = React.useState(false);
    const [error, setError] = React.useState('');
    const [dueError, setDueError] = React.useState('');
    const [launchError, setLaunchError] = React.useState('');

    const user = useSelector(state => state.user.user);

    const text = {
        title: SystemText('Pathways/Enrol/Title', profile?.first_Name),
        fieldTitle: SystemText('Pathways/Enrol/Fields/Pathway/Title'),
        fieldHelp: SystemText('Pathways/Enrol/Fields/Pathway/Help'),
        fieldError: SystemText('Pathways/Enrol/Fields/Pathway/Error'),
        enrol: SystemText('Pathways/Enrol/Buttons/Enrol'),
        cancel: SystemText('Pathways/Enrol/Buttons/Cancel'),
        success: SystemText('Pathways/Enrol/Success'),
    };

    React.useEffect(() => {
        const today = new Date();
        const future = addDays(today, 28);
        setLaunch(new Date(today.getFullYear(), today.getMonth(), today.getDate()));
        setDue(new Date(future.getFullYear(), future.getMonth(), future.getDate()));
        setPathwayId(null);
        setError('');
        setDueError('');
        setLaunchError('');
        setSaving(false);
    }, [show]);

    const validate = () => {
        let result = true;

        if (!pathwayId) {
            setError(text.fieldError);
        }

        if (!due || due?.length === 0 || due === '1970-01-01') {
            setDueError(SystemText('PathwayTracker/Schedule/Fields/Date/Error'));
            result = false;
        } else if (isPast(endOfDay(due))) {
            setDueError(SystemText('PathwayTracker/Schedule/Fields/Date/Error/Past'));
            result = false;
        } else if (due < launch) {
            setLaunchError(SystemText('PathwayTracker/Schedule/Fields/Launch/Error/Past'));
            result = false;
        }

        return result;
    };

    const api = {
        enroll: () => {
            if (validate()) {
                apiPost(
                    `pathway-enroll`,
                    { id: pathwayId, launch, date_Due: due, assigned_Ids: [profile.id] },
                    user.guid,
                    () => {
                        reload();
                        close();
                        setSaving(false);
                        dispatch(setShowSuccess(text.success));
                    }
                );
            } else {
                setSaving(false);
            }
        },
    };

    const footer = (
        <div>
            <SaveButton
                data-testid="button-enrol"
                setSaving={setSaving}
                saving={saving}
                className="btn btn-success"
                onClick={() => api.enroll()}
            >
                {text.enrol}
            </SaveButton>
            <button data-testid="button-cancel" className="btn" onClick={() => close()}>
                {text.cancel}
            </button>
        </div>
    );

    return (
        <Modal
            show={show}
            close={close}
            title={text.title}
            footer={footer}
            toggleFormHelp={() => dispatch(toggleFormHelp())}
        >
            <div>
                <Forms.Select
                    data-testid="select-pathway"
                    label={text.fieldTitle}
                    help={text.fieldHelp}
                    data={pathways}
                    value={pathwayId}
                    onChange={x => setPathwayId(x)}
                    mandatory
                    error={error}
                />
                <Forms.Date
                    data-testid="field-launch-date"
                    showTime
                    mandatory
                    value={launch}
                    help={SystemText('PathwayTracker/Schedule/Fields/Launch/Help')}
                    onChange={setLaunch}
                    label={SystemText('PathwayTracker/Schedule/Fields/Launch/Label')}
                    error={launchError}
                />
                <Forms.Date
                    data-testid="field-review-date"
                    value={due}
                    help={SystemText('PathwayTracker/Schedule/Fields/Date/Help')}
                    onChange={setDue}
                    label={SystemText('PathwayTracker/Schedule/Fields/Date/Label')}
                    mandatory
                    error={dueError}
                />
            </div>
        </Modal>
    );
};

export default Enroll;
